import { render, staticRenderFns } from "./Wp_jd_help.vue?vue&type=template&id=3290cb00&scoped=true&"
import script from "./Wp_jd_help.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3290cb00",
  null
  
)

export default component.exports